import { useCallback, useState } from "react";
export function useFullscreenImage() {
    const [open, setOpen] = useState(false);
    const [fullscreenImage, setFullScreenImage] = useState(null);
    const [origin, setOrigin] = useState("center center");
    const openImage = useCallback((event, picture) => {
        const rect = event.currentTarget.getBoundingClientRect();
        const originX = rect.left + rect.width / 2;
        const originY = rect.top + rect.height / 2;
        setOrigin(`${originX}px ${originY}px`);
        setFullScreenImage(picture);
        setOpen(true);
    }, []);
    const closeImage = useCallback(() => {
        setOpen(false);
    }, []);
    const updatePicture = useCallback((list) => {
        if (fullscreenImage) {
            const found = list.find((i) => i.uuid === fullscreenImage.uuid);
            if (found) {
                setFullScreenImage(found);
            }
            else {
                closeImage();
            }
        }
    }, [fullscreenImage, closeImage]);
    return {
        open,
        fullscreenImage,
        origin,
        openImage,
        closeImage,
        updatePicture,
    };
}
